module.exports = __webpack_public_path__ + "static/product5-c-582271e1902b40b1a2f4d0765a81df46.png";